import { render, staticRenderFns } from "./NewBonusPayment.vue?vue&type=template&id=5880f1ac"
import script from "./NewBonusPayment.vue?vue&type=script&lang=js"
export * from "./NewBonusPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports